import { CaseStudyGrid, type CaseStudyCardItem } from '@/legacy/components/sections/CaseStudyCard'

export type PartnerProofSectionProps = {
  title: string
  items: CaseStudyCardItem[]
  variant?: 'home' | 'partnership' | 'blog'
  titleId?: string
  className?: string
}

export const PartnerProofSection = ({
  title,
  items,
  variant = 'partnership',
  titleId: titleIdProp,
  className = '',
}: PartnerProofSectionProps) => {
  if (!items.length) return null

  const titleId = titleIdProp ?? `${variant}-partner-proof-title`
  const classes = [
    'partner-proof-section',
    variant === 'home' ? 'home-cases marketing-section-stack partner-proof-section--home' : '',
    variant === 'partnership' ? 'partnership-proof partner-proof-section--partnership' : '',
    variant === 'blog' ? 'blog-section partner-proof-section--blog' : '',
    className,
  ].filter(Boolean).join(' ')
  return (
    <section className={classes} aria-labelledby={titleId}>
      <h2 id={titleId}>{title}</h2>
      <CaseStudyGrid items={items} variant="blog" />
    </section>
  )
}
